import { Box, type SxProps, styled, type Theme } from '@mui/material';

const Dash = styled('div')(({ theme }) => ({
  background: theme.palette.text.disabled,
  width: '16px',
  height: '1px',
}));

export const EmptyTableCell = ({ sx }: { sx?: SxProps<Theme> }) => (
  <Box
    sx={{
      display: 'flex',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      ...sx,
    }}
    data-testid="empty-table-cell"
  >
    <Dash />
  </Box>
);
